// extracted by mini-css-extract-plugin
export default {"checkboxControl":"RegisterForm_checkboxControl__DbWlg","label":"RegisterForm_label__YPJgM"};